import FeedStockTradingFeedbackFormContent from "../../../domains/FeedStockTradingFeedback/FeedStockTradingFeedbackFormContent";
import FeedStockTradingFeedback from "../../../domains/FeedStockTradingFeedback/FeedStockTradingFeedback";

import planningAndSchedulingReducer from "./reducer";

import {
  openFeedStockTradingFeedbackModal,
  closeModal,
  resetResetFeedStockTradingSubmission,
  setFeedstockTradingFeedbackData,
  clearFeedstockTradingFeedbackData,
  submitFeedstockTradingFeedback,
  submitFeedstockTradingFeedbackSuccess,
  submitFeedstockTradingFeedbackError,
  closeFeedstockTradingTableModal,
  showFeedbackDetails,
  hideFeedbackDetails,
  openFeedstockTradingTableModal,
} from "./actions";

export interface FeedStockTradingFeedbackState {
  feedStockTradingFeedbackFormData: FeedStockTradingFeedbackFormContent | null
  isSubmitting: boolean
  isFeedStockFeedbackFormModalOpen: boolean
  hasSubmissionError: boolean
  submissionSuccess: boolean
  isFeedstockTradingTableModalOpen: boolean
  areFeedbackDetailsShown: boolean
  selectedFeedback: FeedStockTradingFeedback | null
}

export const initialState: FeedStockTradingFeedbackState = {
  feedStockTradingFeedbackFormData: {
    department: "feedstock_trading",
    details: "",
    requirementStatus: "planning_evaluation",
    requirementId: "",
  },
  isSubmitting: false,
  isFeedStockFeedbackFormModalOpen: false,
  hasSubmissionError: false,
  submissionSuccess: false,
  isFeedstockTradingTableModalOpen: false,
  areFeedbackDetailsShown: false,
  selectedFeedback: null,
};

export {
  openFeedStockTradingFeedbackModal,
  closeModal,
  resetResetFeedStockTradingSubmission,
  setFeedstockTradingFeedbackData,
  clearFeedstockTradingFeedbackData,
  submitFeedstockTradingFeedback,
  submitFeedstockTradingFeedbackSuccess,
  submitFeedstockTradingFeedbackError,
  closeFeedstockTradingTableModal,
  showFeedbackDetails,
  hideFeedbackDetails,
  openFeedstockTradingTableModal,
};

export default planningAndSchedulingReducer;